module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/248-russia-1b5d5acdd8cd8dc13ac91e697fb58438.svg";